import React from "react";

function NotFound(props) {
  return <div></div>;
}

export default NotFound;
